import grayLog from './graylog.js';

export function ChatChannel(config, edgeConnection, ws_emitter, storeController) {

  const currentRoom = () => storeController.store.getState().chat.room;

  ws_emitter.addEventListener('topic', event => {
    if (event.detail.room != currentRoom()) return;
    storeController.store.dispatch(storeController.chat.actions.topic(event.detail.message))
  });

  ws_emitter.addEventListener('history', event => {
    if (event.detail.room != currentRoom()) return;
    storeController.store.dispatch(storeController.chat.actions.history(event.detail.messages))
  });

  ws_emitter.addEventListener('message', event => {
    if (event.detail.room != currentRoom()) return;
    const message = event.detail.message;
    if ('content' in message) message.content = getFixedMessageText(message.content);
    storeController.store.dispatch(storeController.chat.actions.message(message));
  });

  ws_emitter.addEventListener('clear_messages', event => {
    console.log('clear_messages', event.detail);
    if (event.detail.room != currentRoom()) return;
    storeController.store.dispatch(storeController.chat.actions.clear_messages());
  });

  ws_emitter.addEventListener('clear_user_messages', event => {
    console.log('clear_user_messages', event.detail);
    if (event.detail.room != currentRoom()) return;
    const user = storeController.store.getState().user;
    const clear_name = event.detail.user_displayname;
    if (user.usename != clear_name && user.displayname != clear_name) {
      storeController.store.dispatch(storeController.chat.actions.clear_user_messages(clear_name));
    }
  });

  ws_emitter.addEventListener('app_panel', event => {
    const { panel, room } = event.detail;
    if (room != currentRoom()) return;
    const { user } = storeController.store.getState();
    if (!panel) {
      storeController.store.dispatch(storeController.chat.actions.app_panel({panel: null}));
    } else if (panel.cbp && !panel.personal && user && user.level !== 'guest') {
      edgeConnection.send({action: 'get_app_panel', room });
    } else {
      storeController.store.dispatch(storeController.chat.actions.app_panel({panel}));
    }
  });

  ws_emitter.addEventListener('app_hidden_cam_access', event => {
    storeController.store.dispatch(storeController.hiddenCamAccess.actions.update_access(event.detail));
  });

  ws_emitter.addEventListener('tokens_left', event =>
    window.FWC.updateUserTokens(event.detail.tokens_left)
  );

  ws_emitter.addEventListener('users', event => {
    const {room, users, virtual_users} = event.detail;
    if (room != currentRoom()) return;
    grayLog.log('chat_get_users_success');
    for (let i = 0; i < virtual_users; i++) {
      const virtualName = 'Guest' + Math.floor(Math.random() * 10000 + 1);
      const virtualUser = {
        id: 'guid-vu-' + Math.random().toString(36).substring(2, 15),
        username: virtualName,
        displayname: virtualName,
        gender: 'Male',
        level: 'guest',
        photo: false,
        color: '000000',
      };
      users.push(virtualUser);
    }
    storeController.store.dispatch(storeController.chat.actions.users(users));
  });

  ws_emitter.addEventListener('join', event => {
    if (event.detail.room != currentRoom()) return;
    storeController.store.dispatch(storeController.chat.actions.join(event.detail.user))
  });

  ws_emitter.addEventListener('leave', event =>
    storeController.store.dispatch(storeController.chat.actions.leave(event.detail.user))
  );


  const maxWordLength = 25; // max word length in chars, to split too long words

  function splitLongWords(str, length, splitWith = '<wbr>') {
    let words = str.split(' ');
    for (let j = 0; j < words.length; j++) {
      let l = words[j].length;
      if (l > length) {
        let result = [], i = 0;
        while (i < l) {
          result.push(words[j].substr(i, length));
          i += length;
        }
        words[j] = result.join(splitWith);
      }
    }
    return words.join(' ');
  }

  function getFixedMessageText(text) {
    let fixed = '' + text;
    // remove tags
    fixed = fixed.replace(/<\/?[^>]+>/gi, '');
    if (!fixed) return '';

    // remove links and sitenames from message
    fixed = fixed.replace(/(?:https?|ftp):\/\/[\n\S]+/g, '');
    if (!fixed) return '';
    fixed = fixed.replace(/(?:www\.)[\n\S]+/g, '');
    if (!fixed) return '';

    // slit long words
    fixed = splitLongWords(fixed, maxWordLength);
    if (!fixed) return '';

    return fixed.trim();
  }

}
